<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="TokNavBar">
    <div v-if="!isHome && !noBack" class="TokNavBar__left" @click="back()">
      <BackGlyph></BackGlyph>
    </div>
    <div class="TokNavBar__center" :class="{ noLeftButton: isHome }">
      <div class="TokNavBar__center__text">
        <div class="TokNavBar__center__text__logo">
          <AliveLogo />
        </div>
        <div class="TokNavBar__center__text__title">
          <div class="TokNavBar__center__text__title">
            <template v-if="get(conf, 'nav', []).length > 0">
              <template v-for="(link, id) in get(conf, 'nav', [])">
                <a v-if="link.active" :href="link.href" :key="id">{{ $t(link.text) }}</a>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="TokNavBar__right">
      <PaywallGlyph v-if="me && me.registered && !isPaywall"
                    @click.native="$router.push('payWall')" />
      <MyMenu></MyMenu>
      <div class="menuBtnContainer" v-if="get(conf, 'nav', []).length > 0">
        <Slide right>
          <template v-for="(link, id) in get(conf, 'nav', [])">
            <a v-if="link.active" :href="link.href" :key="id">{{ $t(link.text) }}</a>
          </template>
        </Slide>
      </div>
    </div>
  </section>
</template>

<script lang="js">
// import SearchGlyph from '@/components/glyphs/SearchGlyph.vue';
import { get } from 'lodash';
import { mapMutations, mapGetters, mapState } from 'vuex';
import { Slide } from 'vue-burger-menu';
import PaywallGlyph from '@/components/glyphs/PaywallGlyph.vue';
import AliveLogo from '@/components/glyphs/AliveLogo.vue';
import BackGlyph from '@/components/glyphs/BackGlyph.vue';
import MyMenu from '@/components/MyMenu.vue';

export default {
  name: 'nav-bar',
  props: ['title', 'noBack'],
  computed: {
    ...mapState(['me', 'anim', 'conf']),
    ...mapGetters(['getNavTitle']),
    isHome() {
      return this.$route.path === '/';
    },
    isPaywall() {
      return this.$router.currentRoute.name === 'PayWall';
    },
  },
  data() {
    return {
      get,
    };
  },
  components: {
    AliveLogo,
    BackGlyph,
    PaywallGlyph,
    MyMenu,
    Slide,
  },
  methods: {
    ...mapMutations([
      'appReady',
      'displayPaywall',
      'reverseAnimation',
    ]),
    back() {
      this.reverseAnimation();
      this.appReady(false);
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss">
.menuBtnContainer {
  @media (min-width: 799px) {
    display: none;
  }
  margin-right: 10px;
  position: relative;
  .bm-burger-button {
    position: static;
  }
  .bm-burger-bars {
    background-color: #F0DC00;
  }
  a {
    font-size: 18px;
    font-family: Roboto;
    font-weight: 500;
    text-transform: uppercase;
    color: #9A9A9A;
  }
}
</style>
